import React from 'react'

const AgTechFormBody = (props: {
    classes?: string,
    children: JSX.Element | React.ReactNode[]
}) => {
    return (
        <div className={`stretched row-based ${props.classes ?? ''} flex`}>
            {props.children}
        </div>
    )
}

export default AgTechFormBody